module.exports = "/_next/static/images/regulatory-compliance-header-933cc662dbacbb7ad7d63dcf55c253d0.webp";